<template>
	<div>
		<div>
			<Button type="primary" icon="ios-search" @click="searchByConditionsView">搜索</Button>
			<Button type="primary" icon="md-cloud-upload" style="margin-left: 20px;"
				@click="clickImport">导入Excel</Button>
			<Button type="primary" style="margin-left: 20px;" @click="downTemplate">下载模版</Button>
			<Button type="primary" style="margin-left: 20px;" @click="clickBatchDelete">批量删除</Button>
		</div>

		<Table ref="table" size="large" border stripe :loading="loading" :columns="columns1" :data="data1"
			@on-selection-change="onSelectionChange" style="margin: 20px 0;">
			<template slot-scope="{ row, index }" slot="deparams">
				<div style="display: flex;justify-content: space-around;">
					<Button v-if="row.companyNum==null||row.companyNum==''" type="primary"
						@click="clickBindCompany(row)" style="padding: 5px 5px 6px;">绑定公司</Button>
					<Button v-else type="primary" @click="clickUnbindCompany(row)"
						style="padding: 5px 5px 6px;">解绑公司</Button>
					<Button v-if="row.addressId==null||row.addressId==''" type="primary" @click="clickBindAddress(row)"
						style="padding: 5px 5px 6px;">绑定地址</Button>
					<Button v-else type="primary" @click="clickUnbindAddress(row)"
						style="padding: 5px 5px 6px;">解绑地址</Button>
					<Button type="primary" @click="clickShow(row)" style="padding: 5px 5px 6px;">查看详情</Button>
					<Button type="primary" @click="clickUpdate(row)" style="padding: 5px 5px 6px;">编辑</Button>
					<Button type="primary" @click="clickDelete(row)" style="padding: 5px 5px 6px;">删除</Button>
				</div>
			</template>
		</Table>
		<Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />

		<Upload ref="upload" name="file" :action="importUrl" :on-success="onUploadSuccess" :format="['xlsx','xls']"
			:show-upload-list="false" style="display: none;">
			<Button />
		</Upload>

		<Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
			<p slot="header" style="color:#0066FF;text-align:center">
				<Icon type="md-create" />
				<span>搜索</span>
			</p>
			<div style="text-align:center">
				<CheckboxGroup v-model="selectedCondition" class="check_grop">
					<div>
						<Checkbox label="meterId">
							<span>表号</span>
						</Checkbox>
						<Input v-model="meterId" placeholder="请输入表号" style="width: 200px" />
					</div>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button icon="md-search" type="info" size="large" long @click="searchByCondition">检索</Button>
			</div>
		</Modal>

		<Modal title="Title" v-model="showBindCompany" width="500">
			<p slot="header" style="color:#0066FF;text-align:center">
				<span>绑定公司</span>
			</p>
			<div style="text-align: center;">
				<Input v-model="bindCompanyNum" placeholder="请输入公司编号" style="width: 200px;" />
				&nbsp;
				<Button type="primary" :loading="submitLoading" @click="submitBindCompany">立即绑定</Button>
			</div>
			<div slot="footer">

			</div>
		</Modal>

		<Modal title="Title" v-model="showBindAddress" width="500">
			<p slot="header" style="color:#0066FF;text-align:center">
				<span>绑定地址</span>
			</p>
			<div style="text-align: center;">
				<Input v-model="bindAddressId" placeholder="请输入地址编号" type="number" style="width: 200px;" />
				&nbsp;
				<Button type="primary" :loading="submitLoading" @click="submitBindAddress">立即绑定</Button>
			</div>
			<div slot="footer">

			</div>
		</Modal>

		<Modal title="Title" v-model="showDialog" class="common_update_dialog">
			<div slot="header">
				<span>{{showTitle}}</span>
			</div>
			<div>
				<span>厂家</span>
				<Input :readonly="showType=='show'" v-model="currentRow.manufacturer" />
			</div>
			<div>
				<span>规格</span>
				<Input :readonly="showType=='show'" v-model="currentRow.specifications" />
			</div>
			<div>
				<span>最大量程</span>
				<Input :readonly="showType=='show'" v-model="currentRow.maxRange" />
			</div>
			<div>
				<span>进气方向</span>
				<Input :readonly="showType=='show'" v-model="currentRow.direction" />
			</div>
			<div>
				<span>表底数</span>
				<Input :readonly="showType=='show'" v-model="currentRow.baseNumber" type="number" />
			</div>
			<div>
				<span>回转体积</span>
				<Input :readonly="showType=='show'" v-model="currentRow.rotationVolume" />
			</div>
			<div>
				<span>齿轮比</span>
				<Input :readonly="showType=='show'" v-model="currentRow.gearRatio" />
			</div>
			<div>
				<span>生成齿轮系数</span>
				<Input :readonly="showType=='show'" v-model="currentRow.gearCoefficient" />
			</div>
			<div v-if="showType=='show'">
				<span>创建时间</span>
				<Input readonly v-model="currentRow.createTime" />
			</div>
			<div slot="footer">
				<Button v-if="showType=='update'" :loading="submitLoading" type="info" size="large" long
					@click="submitUpdate">立即提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		name: "meter_base_manage",
		data() {
			let that = this;
			return {
				columns1: [{
						type: "selection",
						width: 50,
						align: "center"
					},
					{
						title: "编号",
						width: 200,
						key: "num",
						align: "center"
					},
					{
						title: "公司编号",
						width: 150,
						key: "companyNum",
						align: "center"
					},
					{
						title: "地址编号",
						width: 150,
						key: "addressId",
						align: "center"
					},
					{
						title: "户主身份证号",
						width: 200,
						key: "customerIdCard",
						align: "center"
					},
					{
						title: "激活时间",
						width: 200,
						key: "activateTime",
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								global.dateFtt(
									"yyyy-MM-dd hh:mm:ss",
									new Date(params.row.activateTime)
								)
							);
						}
					},
					{
						title: "型号",
						width: 200,
						key: "model",
						align: "center"
					},
					{
						title: "版本",
						width: 200,
						key: "version",
						align: "center"
					},
					{
						title: "规格",
						width: 200,
						key: "hardwareSpecifications",
						align: "center"
					},
					{
						title: "操作",
						fixed: 'right',
						width: 400,
						slot: "deparams",
						align: "center"
					}
				],
				meterId: '',
				importUrl: '/api/meter/admin/base/imports',
				templateUrl: 'http://www.cnzhuocheng.cn/' + encodeURIComponent('基表导入模板.xls'),
				selection: [],
				currentRow: {},
				data1: [],
				loading: false,
				submitLoading: false,
				modal8: false,
				currentPage: 1,
				totalRows: 0,
				pageSize: 30,
				selectedCondition: [],
				requestBody: {},
				showBindCompany: false,
				bindCompanyNum: '',
				showBindAddress: false,
				bindAddressId: '',
				showType: 'show',
				showTitle: '详情',
				showDialog: false,
			};
		},
		created() {
			this.getDataList();
		},
		mounted() {

		},
		methods: {
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			clickImport() {
				this.$refs.upload.$el.children[0].children[0].dispatchEvent(new MouseEvent('click'));
			},
			onUploadSuccess(response, file, fileList) {
				if (!response.success) {
					this.$Notice.error({
						title: "异常",
						desc: response.msg
					});
					this.getDataList();
					return;
				}

				this.$Notice.success({
					title: "提示",
					desc: "导入" + response.data.count + "条，" +
						'成功' + response.data.successCount +
						'条，失败' + response.data.failureCount +
						'条，忽略' + response.data.skipCount + '条'
				});
				this.getDataList();
			},
			downTemplate() {
				window.location.href = this.templateUrl + "?" + new Date();
			},
			clickBatchDelete() {
				let that = this;
				if (that.selection.length == 0) {
					that.$Notice.info({
						title: "提示",
						desc: "请选择数据"
					});
					return;
				}

				let numArray = [];
				for (let i in that.selection) {
					let num = that.selection[i].num;
					numArray.push(num);
				}
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认批量删除？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/base/batchDelete",
							type: "post",
							data: {
								numJoin: numArray.join(',')
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									return;
								}

								that.getDataList();
							},
							error: function() {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			onSelectionChange(selection) {
				this.selection = selection;
			},
			clickBindCompany(row) {
				this.currentRow = row;
				this.bindCompanyNum = '';
				this.showBindCompany = true;
			},
			submitBindCompany() {
				let that = this;
				if (that.bindCompanyNum == '') {
					that.$Notice.info({
						title: "提示",
						desc: "请输入公司编号"
					});
					return;
				}
				that.submitLoading = true;
				$.ajax({
					url: "/api/meter/admin/base/bindCompany",
					type: "post",
					data: {
						num: that.currentRow.num,
						companyNum: that.bindCompanyNum
					},
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "绑定成功"
						});
						that.showBindCompany = false;
						that.getDataList();
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.submitLoading = false;
					}
				});
			},
			clickUnbindCompany(row) {
				let that = this;
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认解绑？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/base/unbindCompany",
							type: "post",
							data: {
								num: row.num
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									return;
								}

								that.$Notice.success({
									title: "提示",
									desc: "解绑成功"
								});
								that.getDataList();
							},
							error: function(textStatus) {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			clickBindAddress(row) {
				this.currentRow = row;
				this.bindAddressId = '';
				this.showBindAddress = true;
			},
			submitBindAddress(row) {
				let that = this;
				if (that.bindAddressId == '') {
					that.$Notice.info({
						title: "提示",
						desc: "请输入地址编号"
					});
					return;
				}
				that.submitLoading = true;
				$.ajax({
					url: "/api/meter/admin/base/bindAddress",
					type: "post",
					data: {
						num: that.currentRow.num,
						addressId: that.bindAddressId
					},
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "绑定成功"
						});
						that.showBindAddress = false;
						that.getDataList();
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.submitLoading = false;
					}
				});
			},
			clickUnbindAddress(row) {
				let that = this;
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认解绑？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/base/unbindAddress",
							type: "post",
							data: {
								num: row.num
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									return;
								}

								that.$Notice.success({
									title: "提示",
									desc: "解绑成功"
								});
								that.getDataList();
							},
							error: function(textStatus) {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			clickShow(row) {
				this.currentRow = row;
				this.showType = 'show';
				this.showTitle = '详情';
				this.showDialog = true;
			},
			clickUpdate(row) {
				this.currentRow = row;
				this.showType = 'update';
				this.showTitle = '编辑';
				this.showDialog = true;
			},
			submitUpdate() {
				let that = this;
				that.submitLoading = true;
				delete that.currentRow.createTime;
				delete that.currentRow.activateTime;
				$.ajax({
					url: "/api/meter/admin/base/update",
					type: "post",
					data: that.currentRow,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "提交成功"
						});
						that.showDialog = false;
						that.getDataList();
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.submitLoading = false;
					}
				});
			},
			clickDelete(row) {
				let that = this;
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认删除？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/base/delete",
							type: "post",
							data: {
								num: row.num
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									that.getDataList();
									return;
								}

								that.getDataList();
							},
							error: function() {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			// 修改页面容量
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.currentPage = index;
				this.getDataList();
			},
			// 按条件检索点击事件
			searchByCondition() {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.modal8 = false;
				this.currentPage = 1;
				this.getDataList();
			},
			getDataList() {
				var that = this;
				that.loading = true;
				if (localStorage.getItem("isAdmin") != "true") {
				that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
    			}
				$.ajax({
					url: "/api/meter/admin/base/getPage?currentPage=" +
						that.currentPage +
						"&pageSize=" +
						that.pageSize +
						"&paging=true",
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
						that.selection = [];
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			searchByConditionsView() {
				this.modal8 = true;
			}
		}
	};
</script>

<style>
	.ivu-notice-notice {
		width: 500px;
		right: 160px;
	}

	.query_condition {
		border: 1px solid #c0c0c0;
		padding: 2px;
		margin: 2px;
		border-radius: 5%;
	}

	.check_grop div {
		margin-bottom: 1px;
	}
</style>
